// extracted by mini-css-extract-plugin
module.exports = {"page":"_invitation-expired-styles-module--page--c7hTZ","body":"_invitation-expired-styles-module--body--2Xx_x"};